export const GLOBAL_STATE = 'HelpDesk'

export const HELP_DESK_TICKETS = 'HELP_DESK_TICKETS' as const
export const HELP_DESK_TICKETS_LIST = 'HELP_DESK_TICKETS_LIST' as const
export const HELP_DESK_TICKETS_ALL = 'HELP_DESK_TICKETS_ALL' as const
export const HELP_DESK_TICKETS_CREATE = 'HELP_DESK_TICKETS_CREATE' as const
export const HELP_DESK_TICKETS_DELETE = 'HELP_DESK_TICKETS_DELETE' as const
export const HELP_DESK_TICKETS_UPDATE = 'HELP_DESK_TICKETS_UPDATE' as const
export const HELP_DESK_TICKETS_OWN = 'HELP_DESK_TICKETS_OWN' as const
